module.exports = __webpack_public_path__ + "static/img_2383-633a4b5f96f290f5042b40486a8ddeb7.webp";